import {
  put, call, takeLatest, all,
} from 'redux-saga/effects';
import NetworkService from 'services/networkService';
import { changeEndedStatus, changeLoadingState, setErrorMessage } from 'app/settings/slices';
import SuperiorCountriesActionType from 'actions/superiorCountries/superiorCountriesActionType';
import { AppConstants } from 'constants/index';
import { getError } from 'utils/helpers';
import { saveSuperiorCountries } from 'actions/superiorCountries/superiorCountriesActionCreator';
import qs from 'qs';
import { isJSON } from 'utils/utils';

function* getSuperiorCountries({ payload }) {
  try {
    const { key } = payload;
    const options = {
      params: payload.params,
      paramsSerializer: (params) => qs.stringify(params),
    };
    yield put(changeLoadingState(true));
    const { BrandAdmin, SuperiorList, Countries } = AppConstants.api;
    const { data } = yield call(NetworkService.makeAPIGetRequest, [BrandAdmin, SuperiorList, Countries], options);
    yield put(changeLoadingState(false));
    yield put(saveSuperiorCountries(data, key));
  } catch (err) {
    if (err && !isJSON(err.message)) {
      const error = getError(err);
      yield put(setErrorMessage(error));
    }
    yield put(changeLoadingState(false));
  }
}

function* editSuperiorCountries({ payload }) {
  try {
    const { data } = payload;
    const options = {
      data,
    };
    yield put(changeLoadingState(true));
    const { BrandAdmin, SuperiorList } = AppConstants.api;
    yield call(NetworkService.makeAPIPutRequest, [BrandAdmin, SuperiorList], options);
    yield put(changeLoadingState(false));
    yield put(changeEndedStatus(true));
  } catch (err) {
    if (err && !isJSON(err.message)) {
      const error = getError(err);
      yield put(setErrorMessage(error));
    }
    yield put(changeLoadingState(false));
  }
}

function* deleteSuperiorCountries({ payload }) {
  try {
    const { data } = payload;
    const options = {
      data,
    };
    yield put(changeLoadingState(true));
    const { BrandAdmin, SuperiorList } = AppConstants.api;
    yield call(NetworkService.makeAPIDeleteRequest, [BrandAdmin, SuperiorList], options);
    yield put(changeLoadingState(false));
    yield put(changeEndedStatus(true));
  } catch (err) {
    if (err && !isJSON(err.message)) {
      const error = getError(err);
      yield put(setErrorMessage(error));
    }
    yield put(changeLoadingState(false));
  }
}

export default function* systemSettingSaga() {
  yield all([
    takeLatest(SuperiorCountriesActionType.GET_SUPERIOR_COUNTRIES, getSuperiorCountries),
    takeLatest(SuperiorCountriesActionType.EDIT_SUPERIOR_COUNTRIES, editSuperiorCountries),
    takeLatest(SuperiorCountriesActionType.DELETE_SUPERIOR_COUNTRIES, deleteSuperiorCountries),
  ]);
}
